<template>
    <div>
      <FormulaBanner :title="title" :formulaCode="formulaCode"/>
      <div class="index">
        <!-- 表单 -->
        <div>
          <div class="top_nav"><span></span>{{ title }}
          </div>
          <div class="formBody">
            <!-- 表单 -->
            <van-form @submit="onSubmit">
              <MyPatient :memberId="memberId" :selectValue="selectValue" @change="userChange"/>
              <van-field
                  v-model="rongji"
                  :rules="[{ required: true, message: '请输入' }]"
              >
                <template #input>
                  <div class="titles">
                    <span class="titlesName">容积<i>*</i></span>
                    <span style="display: flex;">
                      <span class="information">
                        <van-cell-group class="vanCell"  style="width:166px">
                          <van-field input-align="right" v-model="rongji"  placeholder="请输入" />
                        </van-cell-group>
                      </span>
                      <div class="unit"><span>L</span></div>
                    </span>
                  </div>
                </template>
              </van-field>
              <van-field
                  v-model="YQPYL"
              >
                <template #input>
                  <div class="titles">
                    <span class="titlesName">氧气瓶压力</span>
                    <span style="display: flex;align-items: center;">
                     <span class="information">
                       <van-cell-group class="vanCell" style="width:166px">
                         <van-field input-align="right"  v-model="YQPYL" placeholder="请输入" />
                       </van-cell-group>
                     </span>
                     <div class="unit"> <span>MPa</span></div>
                   </span>
                  </div>
                </template>
              </van-field>
              <van-field
                  v-model="SYYL"
              >
                <template #input>
                  <div class="titles">
                    <span class="titlesName">剩余压力</span>
                    <span style="display: flex;">
                     <span class="information">
                       <van-cell-group class="vanCell" style="width:166px">
                         <van-field input-align="right" v-model="SYYL" placeholder="请输入" />
                       </van-cell-group>
                     </span>
                     <div class="unit"><span>MPa</span></div>
                   </span>
                  </div>
                </template>
              </van-field>
              <div v-if="compute === true" style="margin: 16px;display: flex;justify-content: center;">
                <van-button class="formula-template-button" block type="info"  native-type="submit" style="width:90px">提交</van-button>
              </div>
            </van-form>
          </div>
        </div>
        <!-- 计算结果 -->
        <multipleResult v-if="show" :countText="countText" :countTextList="countResultARR"></multipleResult>


        <!-- 后台设置的值 -->
        <!-- <div v-if="tableData.explain && tableData.explain.length > 0">
          <div v-for="(item,index) in tableData.explain" :key="index" class="StandardDescription">
            <div class="top_nav"><span></span>{{item.title}}</div>
            <div class="StandardDeatil">
              <span v-html="item.value">
              </span>
            </div>
          </div>
        </div> -->
        <!-- 后台设置的值 -->
        <FormulaExplain :explain-data="StandardDescription"></FormulaExplain>
        <!-- 参考文献 -->
        <FormulaReferences :references-data="references"></FormulaReferences>
      </div>
  
    </div>
  
  </template>
  
  <script>
  import MyPatient from '@/components/MyPatient.vue'
  import FormulaBanner from '@/components/FormulaBanner.vue'
  import {Toast} from "vant";
  import {getAdmins} from "@/utils/adminDate";
  import {setById} from "@/service/base";
  import {getFormula, getFormulaHuiXian, postFormula} from "@/service/BodyMassIndex_api";
  import multipleResult from "@/components/multipleResult";
  import FormulaReferences from "../../../components/template1/FormulaReferences.vue";
  import FormulaExplain from "@/components/template1/FormulaExplain";
  export default {
    name: "medicalSearch",
    data(){
      return{
        compute:true,
        show:false,
        countTextList:[],
        countResultARR:[],
        formulaCode: '',
        HR:'',
        SYYL: '',
        chaolv:'',
        YQPYL:'',
        yingjizhishu: '',
        title: '氧气储气量',
        memberId: '1111',
        selectValue: '',
        username:"",
        value:"",
        showPopover: false,
        showPicker: false,
        rongji: '',
        xingbie: null,
        tableData: {},
        countText: '',
        patientId: null,
        result: null,
        yingjizhishuzhi: '',
        xueqingnanongdu: '',
        BSA:'',
        XSCCO:'',
        CRRT:'',
        nianling:'',
        references: [],
        StandardDescription: [],
        liLun:undefined,
        shiji:undefined,
        shengyu:undefined,
      }
    },
    components: {
      FormulaBanner,
      MyPatient,
      multipleResult,
      FormulaReferences,
      FormulaExplain
    },
    async created() {
      await this.test()
      await this.getTableData()
    },
    watch:{
      "SYYL":{
        immediate:true,
        handler:function(){
          this.show = false;
        }
      },
      "YQPYL":{
        immediate:true,
        handler:function(){
          this.show = false;
        }
      },
      "rongji":{
        immediate:true,
        handler:function(){
          this.show = false;
        }
      }
    },
    methods:{
      coumputTetxt () {
        const rongji = Number(this.rongji);
        const YQPYL = Number(this.YQPYL);
        const SYYL = Number(this.SYYL);
        // 理论存储气量=容积x气瓶压力x10
        // 实际可用气量=容积x气瓶压力x8
        // 剩余存储气量=容积x剩余压力x10
        this.liLun = YQPYL === 0? '无法计算':(rongji * YQPYL * 10).toFixed(2)
        this.shiji = YQPYL === 0? '无法计算':(rongji * YQPYL * 8).toFixed(2)
        this.shengyu = SYYL === 0? '无法计算':(rongji * SYYL * 10).toFixed(2)
        this.countTextList = [`理论存储气量 ${this.liLun} L；`,`实际可用气量 ${this.shiji} L；`,`剩余存储气量 ${this.shengyu} L`]

        // 结果传参
        this.countResultARR = 
          [
            {name:'理论存储气量',result:this.liLun ,unit:this.liLun === '无法计算'? '':'L'},
            {name:'实际可用气量',result:this.shiji ,unit:this.shiji === '无法计算'? '':'L'},
            {name:'剩余存储气量',result:this.shengyu,unit:this.shengyu === '无法计算'? '':'L'}
          ]
      },
      async test(){
        //像接口头部传用户信息
        let arrays = await getAdmins(this.$route.query.memberId,this.$route.query.channel)
        this.channel = arrays.os
        this.version = arrays.version
        this.ip = arrays.ip
        await setById(arrays)
      },
      async getTableData () {
        const data = {
          channel: this.$router.currentRoute.query.channel,
          code: 'ISRTXFRP',
        }
        const res = await getFormula(data.channel, data.code)
        if (res.code === 0) {
          this.tableData = res.data
          this.formulaCode = res.data.code
          this.references = res.data.references; // 参考文献
          this.StandardDescription = res.data.explain; // 存储标准说明
        }
        if (this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' && this.$router.currentRoute.query.logId) {
          const data = {
            id: this.$router.currentRoute.query.logId
          }
          const res = await getFormulaHuiXian(data)
          if (res.code === 0) {
            this.YQPYL = res.data.content.YQPYL.value
            this.rongji = res.data.content.rongji.value
            this.SYYL = res.data.content.SYYL.value
            if (res.data.patientId) this.selectValue = {id: res.data.patientId, name: res.data.patientName}
            this.coumputTetxt()
          }
          this.$nextTick(() => {
            this.show=true
          })
          // this.compute = false
        }
      },
      async submit () {
        this.coumputTetxt()
      },
      calculateAge(birthDateString) {
        const today = new Date();
        const birthDate = new Date(birthDateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        // 如果今天的日期还没到生日月份和日期，则年龄减一
        if (today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      },
      // 开参考文献链接
      openLink(u){
        if (!u) {
          return
        }
        //获取系统版本
        let userAI = navigator.userAgent;
        const isAndroid = userAI.indexOf('Android') > -1 || userAI.indexOf('Linux') > -1; //Android终端
        const isIOS = !!userAI.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isAndroid) {
          // alert('安卓操作系统')
          // 这个是安卓操作系统
          window.open(u)
        }
        if (isIOS) {
          // 这个是ios操作系统
          // alert('ios操作系统')
          window.location.href = u
        }
      },
      yingjiClick () {
        this.showPicker = true
      },
      onConfirm(value) {
        this.yingjizhishu = value
        this.showPicker = false
      },
      onCancel() {
        this.showPicker = false
      },
      async onSubmit(){
        if(this.SYYL === '' && this.YQPYL === ''){
           Toast.fail('请输入氧气瓶压力或剩余压力')
           return
        }
        this.coumputTetxt()
        const data = {
          id: this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' ? this.$router.currentRoute.query.logId : null,
          patientId: this.patientId,
        //   columnCode: this.tableData.columnCode,
          columnCode: 'jsgs',
          formulaCode: this.tableData.code,
          channel: this.$router.currentRoute.query.channel,
          location: this.$router.currentRoute.query.location,
          content: {
            SYYL: {value: this.SYYL, unit: 'MPa'},
            YQPYL: {value: this.YQPYL, unit: 'MPa'},
            rongji: {value: this.rongji, unit: 'L'},
          },
          result: {
            liLun: this.liLun,
            shiji: this.shiji,
            shengyu: this.shengyu,
            DisplayResults:this.countTextList[0]+';'+this.countTextList[1]+';'+this.countTextList[2]
          }
        }
        const res = await postFormula(data)
        if (res.code === 0) {
          Toast.success('提交成功')
          this.show=true
        } else {
          Toast.fail(res.message)
          this.show=true
        }
      },
      userChange (data) {
        if (data.birthday && data.birthday !== '') {
          this.nianling = this.calculateAge(data.birthday)
        } else {
          this.nianling = ''
        }
        this.xingbie = data.sex
        this.patientId = data.id
        this.selectValue = data
      },
    }
  }
  </script>
  
  
  <style scoped lang="scss">
  .index{
    background: #F6F6F6;
    padding: 10px 15px;
    min-height: 100vh;
    .StandardDescription{
      margin-top:10px;
      .top_nav{
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: start;
        margin-bottom:10px;
        span {
          display: inline-block;
          width: 5px;
          height: 15px;
          background: #259beb;
          margin-right: 5px;
        }
      }
      .StandardDeatil{
        width:100%;
        padding:15px 10px;
        //   height: 50px;
        background-color: #fff;
        box-sizing: border-box;
      }
    }
    .top_nav{
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: start;
      margin-bottom:10px;
      span {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: #259beb;
        margin-right: 5px;
      }
    }
    .formBody{
      background-color: #fff;
      padding-bottom:10px;
      .multipleResultBox{
        padding:0 8px;
        .multipleResult{
          font-size: 16px;
          color: #333333;
          font-weight: bold;
          display: flex;
          justify-content: center;
          margin-bottom:10px
        }
        .CalculationDetail{
          font-size: 15px;
          color: #333333;
          // font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: start;
          margin-bottom:10px;
          background-color: #f6f6f6;
          // height: 16px;
          span{
            display: inline-block;
            width: 3px;
            height: 24px;
            background: #fe9712;
            margin-right: 5px;
          }
        }
      }
    }
    .titles{
      display:flex;
      align-items: center;
      justify-content: space-between;
      width:100%;
      height: 50px;
      border-bottom: 1px solid #f0f0f0;
      padding: 0 10px;
      box-sizing: border-box;
      .titlesName{
        font-size:16px;
        i{
          color: red;
        }
      }
      .information{
        font-size:16px;
        margin-right:4px;
        .PleaseSelect{
          color: #b9b9b9;
        }
        .vanCell{
          width:50px;
          padding:0;
          height: 100%;
        }
      }
      .vBotton{
        width:60px
      }
      .unit{
        height: 50px;
        //   line-height: 50px;
        display: flex;
        align-items: center;
        font-size:16px;
        // width:40px;
      }
      .vanIcon{
        font-size:13px;
        color:#a8a8a8;
        font-weight: 650;
      }
    }
  }
  ::v-deep .van-cell {
    padding:0px 0px;
  }
  ::v-deep .van-field__control{
    height: 50px;
    font-size: 16px;
  }
  ::v-deep .van-field__error-message {
    position: absolute;
    top: 30px;
    left: 10px;
  }
  .StandardDeatil2{
    width:100%;
    padding: 15px 10px;
    padding-bottom:1px;
    //   height: 50px;
    background-color: #fff;
    box-sizing: border-box;
    .references{
      margin-bottom:15px
    }
  }
  ::v-deep p {
    padding: 0;
    margin: 0;
  }
//   ::v-deep .van-field__control{
//     height: 50px;
//     font-size: 12px;
//   }
// input:-moz-placeholder {
// color: #aab2bd;
// font-size: 12px;
// }
// input::-moz-placeholder {
// color: #aab2bd;
// font-size: 12px;
// }
// input::-webkit-input-placeholder {
//     /* placeholder颜色 */
//     color: #aab2bd;
//     /* placeholder字体大小 */
//     font-size: 12px;
// }

// ::v-deep .custom-field .van-field__control::placeholder {
//   font-size: 12px;
// }

  </style>
  